export const FeesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M2.25 9.5a6.75 6.75 0 1 0 13.5 0 6.75 6.75 0 0 0-13.5 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M11.1 7.25a1.5 1.5 0 0 0-1.35-.75h-1.5a1.5 1.5 0 0 0 0 3h1.5a1.5 1.5 0 0 1 0 3h-1.5a1.5 1.5 0 0 1-1.35-.75m2.1-6v7.5"
    />
  </svg>
);
